export default "__VITE_ASSET__BhTFWSb$__"